import { useTranslation } from 'next-i18next'

import DescriptionDetails from '../DescriptionList/DescriptionDetails/DescriptionDetails'
import DescriptionList from '../DescriptionList/DescriptionList'
import DescriptionTerm from '../DescriptionList/DescriptionTerm/DescriptionTerm'
import { TrackMusicalFeaturesProps } from './TrackMusicalFeatures.types'

const TrackMusicalFeatures = ({
	track,
}: TrackMusicalFeaturesProps): JSX.Element | null => {
	const { t } = useTranslation(['app'])

	const musicalKey = `${track.startKey}${
		track.endKey && track.endKey !== track.startKey
			? ` (${t('ends-in')} ${track.endKey})`
			: ''
	}`

	const bpm = `${track.startBpm} ${t('bpm')}${
		track.endBpm && track.endBpm !== track.startBpm
			? ` (${t('ends-in')} ${track.endBpm} ${t('bpm')})`
			: ''
	}`

	return (
		<DescriptionList>
			{musicalKey && (
				<>
					<DescriptionTerm>{t('key')}</DescriptionTerm>
					<DescriptionDetails>{musicalKey}</DescriptionDetails>
				</>
			)}
			{track.metre && (
				<>
					<DescriptionTerm>{t('metre')}</DescriptionTerm>
					<DescriptionDetails>{track.metre}</DescriptionDetails>
				</>
			)}
			{bpm && (
				<>
					<DescriptionTerm>{t('tempo')}</DescriptionTerm>
					<DescriptionDetails>{bpm}</DescriptionDetails>
				</>
			)}
			{track.tempo && (
				<>
					<DescriptionTerm>{t('tempo-notes')}</DescriptionTerm>
					<DescriptionDetails>{track.tempo}</DescriptionDetails>
				</>
			)}
			{track.trackFact && (
				<>
					<DescriptionTerm>{t('factoid')}</DescriptionTerm>
					<DescriptionDetails>{track.trackFact}</DescriptionDetails>
				</>
			)}
		</DescriptionList>
	)
}

export default TrackMusicalFeatures
